import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { RootState, WkblVideoState } from 'redux/reducers/type';
import {
  Button,
  ClickAwayListener,
  Grow,
  makeStyles,
  MenuList,
  Paper,
  Popper,
  Theme,
  Typography,
  ListItemText,
} from '@material-ui/core';
import { SelectIcon } from 'asset/images';
import { GameTypeOptions, PageReturnOptions, SeasonOptions } from 'components/SelectOptions';
import { StyledMenuItem } from 'components/SelectOptions/GameTypeOptions';
import {
  GameTypeSelectProps,
  PageReturnSelectProps,
  SeasonSelectProps,
} from 'components/Select/type';
import CodeVO from 'commons/vo/CodeVO';

const useStyles = makeStyles((theme: Theme) => ({
  sortOptionButton: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    border: '1px solid #b6b6b6',
    borderRadius: 0,
  },
  buttonTitle: {
    flexBasis: '95%',
    textAlign: 'left',
  },
  popper: {
    zIndex: theme.zIndex.tooltip,
    width: 'calc(100% - 130px)',
  },
  paper: {
    borderRadius: 0,
    maxHeight: '250px',
    overflowY: 'scroll',
  },

  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

function GameTypeSelect({
  gameTypes,
  selectedGameTypes,
  onClickGameType,
}: GameTypeSelectProps) {
  const classes = useStyles();

  const [button, setButton] = useState<null | HTMLButtonElement>(null);
  const isOpen = useMemo(() => Boolean(button), [button]);

  const onOpenMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setButton(event.currentTarget);
  }, []);

  const onCloseMenu = useCallback(() => {
    setButton(null);
  }, []);

  const selectedGameTypeString = useMemo(() => {
    if (selectedGameTypes.length > 0) {
      const firstItem = selectedGameTypes[0];
      const itemCount = selectedGameTypes.length;

      console.log('# selectedGameTypeString', firstItem);

      let gameTypeName = null;
      if (firstItem) {
        gameTypeName = gameTypes.find((gameType: CodeVO) => gameType.id === firstItem);
      }
      // const gameTypeName = gameTypes.find((gameType: CodeVO) => gameType.id === firstItem);
      const otherName =
        itemCount > 1 ? ` 외 ${itemCount - 1} 개` : '';

      return gameTypeName ? `${gameTypeName.name}${otherName}` : null;

      // selectedGameTypes.map((gameTypeId, index) => {
      //   const gameType = gameTypes.find((gameType: CodeVO) => gameType.id === gameTypeId);
      //   return gameType ? `${gameType.name}, ` : null;
      // })
    } else {
      return '항목을 선택해주세요';
    }
  }, [selectedGameTypes]);

  return (
    <>
      <Button className={clsx(classes.sortOptionButton)} onClick={onOpenMenu}>
        <Typography className={clsx(classes.ellipsis, classes.buttonTitle)}>
          {selectedGameTypeString}
        </Typography>
        <img src={SelectIcon}></img>
      </Button>
      <Popper className={clsx(classes.popper)} open={isOpen} anchorEl={button} transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: 'center top',
            }}
          >
            <Paper className={clsx(classes.paper)}>
              <ClickAwayListener onClickAway={onCloseMenu}>
                <MenuList autoFocusItem={isOpen} id="menu-list-grow" onKeyDown={onCloseMenu}>
                  <GameTypeOptions
                    gameTypes={gameTypes}
                    selectedGameTypes={selectedGameTypes}
                    onClickGameType={onClickGameType}
                  />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default GameTypeSelect;
